import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { DropdownField } from 'components/common/input';
import BaseModalForm from 'components/common/modal/BaseModalForm';
import { useFormHandlers } from 'core/hooks/form/formHandlers';
import { Alert } from 'react-bootstrap';
import { MODAL_FORM_ERRORS } from 'core/constant/MODAL_FORM_ERRORS';

const EditProjectFilterModal = ({ show, projectFilter, handleClose, handleSave, updating, errors, requestError, products, filters, filtersOptions }) => {
  const [formValues, setFormValues] = useState(projectFilter);
  const { handleChange } = useFormHandlers(setFormValues);

  useEffect(() => {
    setFormValues(projectFilter);
    console.log(filters);
    console.log(filtersOptions);
  }, [projectFilter]);

  const handleSaveClick = useCallback(() => {
    handleSave({ ...formValues, id: projectFilter?.id });
  }, [formValues, projectFilter?.id, handleSave]);

  const filteredFilterOptions = useMemo(() => {
    return filtersOptions?.filter(option => option.filter_id === formValues?.filter_id) || [];
  }, [filtersOptions, formValues?.filter_id]);

  return (
    <BaseModalForm show={show} title={projectFilter?.id ? "Editar Filtro de Proyecto" : "Crear Filtro de Proyecto"} handleClose={handleClose} handleSave={handleSaveClick} updating={updating}>
      <div className="row">
        <div className="col-md-6 form-group">
          <DropdownField
            label="Proyecto"
            name="project_id"
            value={formValues?.project_id}
            onChange={(e) => handleChange('project_id', e.target.value)}
            options={products?.map(product => ({ label: product.title, value: product.id }))}
            placeholder="Seleccione un proyecto"
            error={errors.project_id}
          />
        </div>
        <div className="col-md-6 form-group">
          <DropdownField
            label="Filtro"
            name="filter_id"
            value={formValues?.filter_id}
            onChange={(e) => handleChange('filter_id', e.target.value)}
            options={filters?.map(filter => ({ label: filter.name, value: filter.id }))}
            placeholder="Seleccione un filtro"
            error={errors.filter_id}
          />
        </div>
        <div className="col-md-12 form-group">
          <DropdownField
            label="Valor de Filtro"
            name="filter_option_id"
            value={formValues?.filter_option_id}
            onChange={(e) => handleChange('filter_option_id', e.target.value)}
            options={filteredFilterOptions.map(option => ({ label: option.value, value: option.id }))}
            placeholder="Seleccione un valor del filtro"
            error={errors.filter_option_id}
          />
        </div>
        <div className="col-12 form-group mt-3">
          {requestError &&
            <Alert variant="danger">
              {requestError?.response?.data?.message ||
               MODAL_FORM_ERRORS.PROJECT_FILTER}
            </Alert>
          }
        </div>
      </div>
    </BaseModalForm>
  );
};

export default React.memo(EditProjectFilterModal);